import React, { useEffect, useContext, useState, useRef } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import systemConfig from '../../../../config/systematic';
import getList from '../../../universal/getList';
import fetchApi from '../../../../utils/api/fetchApi';
import dayjs from 'dayjs';
import antMessage from '../../../../utils/extend/AntdNotification';
import DownloadExcel from '../../../report/DownloadExcel';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';
import entrepotPrint from '../../../../generalMethod/entrepotPrint';
import { useReactToPrint } from 'react-to-print';

const { RangePicker } = DatePicker;

export default function EnBuyPurStatistics() {
  const initialValues: any = {
    chooseTime: [dayjs(), dayjs()],
  };
  const [entrepotData, setEntrepotData] = useState<any>();

  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm();

  const [user, setUser] = useState<any>("");
  const [deptData, setDeptData] = useState<any>();
  const [buyerData, setBuyerData] = useState<any>();
  const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();
  const [queryCriteria, setQueryCriteria] = useState<any>("");
  const notificationApi = useNotificationInstance();
  const useContextData = useContext(SocketContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deptName, setDeptName] = useState<string>("");
  const [buyerName, setBuyerName] = useState<string>("");
  const [printScale, setPrintScale] = useState(1);

  const { contextData, setContextData } = useContextData;
  const [rows, setRows] = useState<any>([]);
  const contentRef = useRef<any>(null);




  const [dataTypeData, setDataTypeData] = useState<Array<any>>();

  useEffect(() => {
    const fetchData = async () => {
      //   let deptData = await fetchApi.GET(wmService, {
      //     apiId: "dept",
      //     apiExtend: 'showList',
      //     apiData: {}
      //   });
      //   if (deptData.success) {
      //     setDeptData(deptData.data);
      //   }

      //   let buyerData = await fetchApi.GET(wmService, {
      //     apiId: "buyer",
      //     apiExtend: 'showList'
      //   });
      //   if (buyerData.success) {
      //     setBuyerData(buyerData.data);
      //   }

      //   let classificationWarehouseData = await fetchApi.GET(wmService, {
      //     apiId: "classificationWarehouse",
      //     apiExtend: 'showList'
      //   });
      //   if (classificationWarehouseData.success) {
      //     setClassificationWarehouseData(classificationWarehouseData.data);
      //   }

      fetchApi.GET(wmService, {
        apiId: 'generalData',
        apiVariable: 'dataStatusType',
        apiExtend: 'showLists'
      }).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data;
          setDataTypeData(dataStatusType);
        }
      });

      //   fetchApi.GET(wmService, {
      //     apiId: 'entrepot',
      //     apiExtend: 'showListEx',
      //     apiData: {
      //       mountDataOptions: {
      //         userMount: {
      //           isUserEntrepots: true
      //         }
      //       },
      //     }
      //   }).then((res) => {
      //     if (res.success) {
      //       setEntrepotData(res.data);
      //     }
      //   });
    };
    fetchData();
  }, []);

  // 数据格式化函数：将后端返回的扁平数组转换为 Table 支持的“分组+合计”结构
  const formatTableData = (apiData: any[]) => {
    if (!apiData || apiData.length === 0) return [];

    // 1. 按 buyerName 分组
    const groupMap = new Map();
    apiData.forEach(item => {
      const buyerName = item.buyerName;
      if (!groupMap.has(buyerName)) {
        groupMap.set(buyerName, []);
      }
      groupMap.get(buyerName).push(item);
    });

    let flatData: any[] = [];
    let indexCounter = 0; // 用于生成唯一 key

    // 2. 遍历分组，构建表格数据
    groupMap.forEach((depts, buyerName) => {
      let buyerTotal = 0;
      const deptCount = depts.length;

      // 添加该供应商下的分店明细
      depts.forEach((dept: any, idx: number) => {
        flatData.push({
          key: `${buyerName}_${indexCounter++}`,
          // 只有该组的第一条数据显示供应商名称
          buyerName: idx === 0 ? buyerName : '',
          // 计算合并行数：分店总数 + 1个合计行。只有第一行需要设置 rowSpan
          rowSpan: idx === 0 ? deptCount + 1 : 0,
          entrepotName: dept.entrepotName, // 分店名称
          amount: dept.amount,
        });
        buyerTotal += parseFloat(dept.amount || 0);
      });

      // 添加该供应商的合计行
      flatData.push({
        key: `${buyerName}_total_${indexCounter++}`,
        buyerName: '', // 合计行不显示供应商名
        rowSpan: 0,    // 合计行被第一行的 rowSpan 合并，此处设为 0
        entrepotName: '合计',
        amount: buyerTotal,
        isTotalRow: true,
      });
    });

    console.log("flatData", flatData);
    return flatData;
  };

  // 定义多级表头
  const columnsHead: ColumnsType<any> = [
    {
      title: '供应商（采购）',
      dataIndex: 'buyerName',
      width: 180,
      // 使用 onCell 返回 rowSpan，AntD 会自动处理单元格合并
      onCell: (record) => ({
        rowSpan: record.rowSpan,
      }),
    },
    {
      title: '分店',
      dataIndex: 'entrepotName',
      width: 200,
    },
    {
      title: '金额',
      dataIndex: 'amount',
      width: 160,
      render: (val: number, record: any) => {
        if (record.isTotalRow) {
          return <strong>{val ? val.toFixed(2) : '-'}</strong>;
        }
        return val ? val.toFixed(2) : '-';
      },
    },
  ];

  const onFinish = () => {
    setIsLoading(true);
    form.validateFields()
      .then(async (values: any) => {
        fetchApi.GET(wmService, {
          apiId: "entrepotReport",
          apiExtend: 'enbuyPurStatistics',
          apiData: {
            ...values,
            time: values.chooseTime ? {
              startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            entrepotId: contextData?.currentEntrepotId,
            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,
            productModel: values.productModel,
            mountDataOptions: {
              userMount: {
                isDept: true
              }
            },
          }
        }).then((res: any) => {
          setIsLoading(false);
          // 核心：调用修复后的格式化函数
          const formattedRows = formatTableData(res.data.rows);
          
          setRows(formattedRows);
          setQueryCriteria(res.data.queryCriteria);
          setUser(res.data.user);
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });
        }).catch((err: any) => {
          setIsLoading(false);
          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors?.status);
        });
      })
      .catch((err) => {
        setIsLoading(false);
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });
      });
  };

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: '报价对比表',


  });



  const changeBuyers = (e: any, option: any) => {
    let buyerName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      buyerName.push(option[i].children);
    }
    setBuyerName(buyerName.join("|"));
  };

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{ productModel: "rangeNumSearch", dataStatusType: 1 }}
      >
        <Row>
          {/* <Col span={12}>
            <Form.Item label="部门" name="deptIds">
              <Select
                mode="multiple"
                showSearch
                placeholder="请选择部门!"
                optionFilterProp="children"
                onChange={changeDept}
                onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input:any, option: any) => true}
              >
                {getList.general(deptData, 'deptName')}
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={12}>
            <Form.Item label="采购商" name="buyers">
              <Select
                onChange={changeBuyers}
                mode="multiple"
                showSearch
                placeholder="采购商"
                optionFilterProp="children"
                onSearch={(e) => getList.search('buyer', setBuyerData, e)}
                filterOption={(input:any, option: any) => true}
              >
                {getList.general(buyerData, 'buyerName')}
              </Select>
            </Form.Item>
          </Col>

          {/* <Col span={6}>
            <Form.Item label="产品模式" name="productModel">
              <Select
                onChange={changeProductModel}
                showSearch
                placeholder="产品模式"
                optionFilterProp="children"
                filterOption={(input:any, option: any) => true}
              >
                {getList.general(productModel, 'name')}
              </Select>
            </Form.Item>
          </Col> */}

          {/* {selectProdutModel === "rangeNumSearch" && (
            <>
              <Col span={3}>
                <Form.Item label="品号" name="selfStart">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item colon={false} label="-" name="selfEnd">
                  <Input />
                </Form.Item>
              </Col>
            </>
          )}

          {(selectProdutModel === "similarNameSearch" || selectProdutModel === "equalNameSearch") && (
            <Col span={3}>
              <Form.Item label="品名" name="productName">
                <Input />
              </Form.Item>
            </Col>
          )}

          {(selectProdutModel === "similarNumSearch" || selectProdutModel === "equalNumSearch") && (
            <Col span={3}>
              <Form.Item label="品号" name="selfId">
                <Input />
              </Form.Item>
            </Col>
          )}

          <Col span={6}>
            <Form.Item label="品类" name="classificationWarehouses">
              <Select
                mode="multiple"
                showSearch
                placeholder="品类"
                optionFilterProp="children"
                onSearch={(e) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                filterOption={(input:any, option: any) => true}
              >
                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="排序类型" name="sortType">
              <Select showSearch placeholder="排序类型" optionFilterProp="children">
                {getList.general(sortType)}
              </Select>
            </Form.Item>
          </Col> */}
          {/* 
          <Col span={6}>
            <Form.Item label="排序方式" name="sortOrder">
              <Select showSearch placeholder="排序方式" optionFilterProp="children" filterOption={(input:any, option: any) => true}>
                {getList.general(sortOrder)}
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={6}>
            <Form.Item label="日期" name="chooseTime" initialValue={initialValues.chooseTime}>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>

          {/* <Col span={1.5}>
            <Form.Item label="当前分店" name="isCurrentBranchStore" valuePropName="checked">
              <Checkbox onChange={onChangeBranchStore} />
            </Form.Item>
          </Col> */}

          {/* <Col span={4}>
            <Form.Item
              label="仓库"
              name="entrepotIds"
              tooltip="选中时，账套切换的仓库数据失效，只支持选中的仓库数据查询"
            >
              <Select
                mode='multiple'
                placeholder="多仓库"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {getList.general(entrepotData, "entrepotName", "entrepotId")}
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={4}>
            <Form.Item name="dataStatusType">
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item>
              <Space>
                <Button loading={isLoading} htmlType="submit">统计</Button>
                <Button onClick={handlePrint}>打印</Button>
                <Button onClick={() => DownloadExcel(rows, "enBuyPurStatistics", { ...queryCriteria, deptName, buyerName })}>
                  下载EXCEL文件
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div ref={contentRef} style={{ marginTop: "20px" }}>
        <div style={{ fontSize: 20, textAlign: "center", marginBottom: 10 }}>收货采购统计表</div>
        <div style={{ fontSize: 16, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between" }}>
          <div>时间:{queryCriteria.date}</div>
          {/* <div>分类:{queryCriteria.classificationWarehouses}</div> */}
          {/* <div>采购商:{buyerName}</div> */}
        </div>
        {/* <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between" }}>
          <div>部门：{deptName}</div>
          <div>品号:{queryCriteria.selfs}</div>
        </div> */}
        <div className="print-table"
          style={{
            // display: 'none',
            transform: `scale(${printScale})`,
            transformOrigin: 'top left',
            width: printScale < 1 ? `${100 / printScale}%` : '100%'
          }}>
          <Table

            pagination={false}
            rowKey="key"
            columns={columnsHead}
            dataSource={rows}
            bordered
            size="small"
          />
        </div>


        <style dangerouslySetInnerHTML={{
          __html: `
                    @media print {
                        /* 2. 隐藏非打印元素 */
                        .no-print, .screen-table {
                            display: none !important;
                        }

                        /* 3. 显示打印表格 */
                        .print-table {
                            display: block !important;
                        }

                        /* 4. ✅ 核心：强制白底黑字 */
                        .print-table table {
                            border-collapse: collapse !important;
                            width: 100% !important;
                            table-layout: auto !important; /* 自动分配列宽 */
                        }

                        /* 表头：白底黑字加粗 */
                        .print-table .ant-table-thead > tr > th {
                            background: #ffffff !important; /* 强制白底 */
                            color: #000000 !important; /* 强制黑字 */
                            border: 1px solid #000000 !important;
                            font-weight: bold !important;
                            font-size: 12px !important;
                            padding: 6px 8px !important;
                        }

                        /* 单元格：白底黑字 */
                        .print-table .ant-table-tbody > tr > td {
                            background: #ffffff !important; /* 强制白底 */
                            color: #000000 !important; /* 强制黑字 */
                            border: 1px solid #000000 !important;
                            font-size: 11px !important;
                            padding: 4px 8px !important;
                            white-space: nowrap !important; /* 防止文字换行撑大表格 */
                        }

                        /* 5. 防止内容跨页截断 */
                        .print-table tr {
                            page-break-inside: avoid !important;
                        }

                        /* 6. 强制打印背景色（解决浏览器省墨模式问题） */
                        body {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }

                        /* 7. 清除Antd残留样式 */
                        .print-table .ant-table-cell-fix-left,
                        .print-table .ant-table-cell-fix-right {
                            position: static !important;
                        }
                        .print-table .ant-table-container,
                        .print-table .ant-table-content,
                        .print-table .ant-table-body {
                            overflow: visible !important;
                            max-height: none !important;
                        }
                    }
                `
        }} />
      </div>
    </>
  );
}